import type { IPlanProductConstructorParams } from "@services/sdk/interfaces";
import type { ID } from "@services/sdk/types";

import Product from "./product";
import ProductItem from "./product-item";

class PlanProduct extends Product {
	public static EmptyConstructorParams: IPlanProductConstructorParams = {
		discountPrice: 0,
		price: 0,
		description: "",
		id: null,
		name: "",
		type: "",
		appUserData: {
			productInclusions: [],
		},
	};

	public static Construct(params: IPlanProductConstructorParams): PlanProduct {
		return new PlanProduct(params);
	}

	public static ConstructEmpty(): PlanProduct {
		return PlanProduct.Construct(PlanProduct.EmptyConstructorParams);
	}

	responseData: IPlanProductConstructorParams;

	constructor(params: IPlanProductConstructorParams) {
		super(params);
		this.responseData = params;
	}

	get id(): ID {
		if (this.responseData.id) {
			return this.responseData.id;
		}

		if (this.responseData.productId) {
			return this.responseData.productId;
		}

		return null;
	}

	get name(): string {
		return this.responseData.name;
	}

	get items(): Array<ProductItem> {
		if (this.responseData && this.responseData.appUserData) {
			return ProductItem.ConstructList(
				this.responseData.appUserData.productInclusions,
			);
		}

		return [];
	}
}

export default PlanProduct;
